export const routesForLanguage = (org = ':org', lang = ':lang') => {
  
  let marketAndLanguage = `${org}/${lang}`;
  const baseRoute = `/dppsi/` + marketAndLanguage.toUpperCase();
  const startPageRoute="/dppsi/"
  return {
    startPageRoute() {
      return startPageRoute;
    },
    redirectRoute() {
      return `${baseRoute}/`;
    },
    menuRoute() {
      return `${baseRoute}/menu`;
    },
    prepAndProdCheatSheetRoute() {
      return `${baseRoute}/prepAndProd`;
    },
    ppsiRoute(id) {
      return id ? `${baseRoute}/ppsi/${id}` : `${baseRoute}/ppsi/:id`;
    },

    ppiRoute(id) {
      return id ? `${baseRoute}/ppi/${id}` : `${baseRoute}/ppi/:id`;
    },

    settingsPageRoute(){
      return `${baseRoute}/settings`;
    },
    baseRoute(){
      return baseRoute;
    }
  };
};
